import styled from "styled-components";
import { mediaMobile } from "utils/styles/responsive";
import { colors, layout } from "utils/styles/theme";

export const Wrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 103rem 84rem;
  pointer-events: none;
  z-index: ${layout.zIndex.header};

  > svg {
    display: block;
    width: 160rem;
  }

  .nissan-svg-shapes {
    fill: ${colors.white};
  }

  ${mediaMobile(`    
    padding: 27rem;
    > svg {
      display: block;
      width: 70rem;
    }
  `)}
`;
